import { useQuery } from "@tanstack/react-query";
import { getExpenseById } from "@/features/expenses/hooks/expense-client";
import { expenseKeys } from "@/features/expenses/hooks/query-keys";

export function useExpenseDetail(id?: string) {
  return useQuery({
    enabled: !!id,
    queryKey: expenseKeys.detail(id ?? ""),
    queryFn: () => getExpenseById(id as string),
    staleTime: 60_000,
  });
}
